import { FC, PropsWithChildren } from "react";

export const SidebarContainer: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="hidden md:block fixed z-40 bg-side-bar-background border-t-4 border-t-indigo-500 w-[267px] h-[calc(100vh-var(--top-bar-height))] py-5 px-[18px]">
      <div className="flex flex-col gap-[15px] h-full">{children}</div>
    </div>
  );
};
